import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { PREDEFINED_URLS } from './TapgoUrls';
import { environment } from '../../environments/environment';

// Function to get the document reference
function getDocumentReference() {
  return inject(DOCUMENT);
}

// Function to determine the base URL
export function getDomainName(): string {
  const document = getDocumentReference();
  const host = document.location.host;
  const pathname = document.location.pathname;
  const tapgoUrls = PREDEFINED_URLS;
  const smashedDomain = environment.smashedDomain;

  if (tapgoUrls.includes(host) && pathname !== '') {
    let domainName = '/' + pathname.split('/')[1];
    if (pathname.toLocaleLowerCase().includes('smashed.ch')) {
      domainName = '/' + smashedDomain;
    }
    return domainName;
  }
  return '/'; // Default base href if conditions don't match
}
